import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { formValues, reduxForm } from 'redux-form'
import { Grid, Header, Icon, Segment, Table } from 'semantic-ui-react'
import ProductCriteriaPropertyRow from './ProductCriteriaPropertyRow'

const i18nkey = 'admin.product.criteria.'

const mapStateToProps = (state, ownProps) => {
  const { properties } = state.properties
  return { properties }
}

class ProductCriteriaProperties extends React.Component {
  state = {
    dragMarker: {},
  }

  moveCriteria(oldIndex, newIndex) {
    // note: see below
    const { array } = this.props //redux form
    array.move('familyCriteriaPropertyIds', oldIndex, newIndex)
  }

  findCriteria(dragId) {
    const { properties = [] } = this.props // redux
    const { familyCriteriaPropertyIds } = this.props //formValues
    const property = properties.find((property) => property.id === dragId)
    return {
      property,
      index: familyCriteriaPropertyIds.indexOf(property.id),
    }
  }

  deleteCriteria(index) {
    // note: see below
    const { array } = this.props //redux form
    array.remove('familyCriteriaPropertyIds', index)
  }

  addCriteria(propertyId) {
    // note: see below
    const { array } = this.props //redux form
    array.push('familyCriteriaPropertyIds', propertyId)
  }

  getCriteriaPropertyRows() {
    const { dragMarker = {} } = this.state
    const { properties = [] } = this.props // redux
    const { familyCriteriaPropertyIds } = this.props //formValues
    return familyCriteriaPropertyIds.map((propertyId, index) => {
      const property =
        properties.find((property) => property.id === propertyId) || {}
      return (
        <ProductCriteriaPropertyRow
          {...{
            key: index,
            index: index,
            dragId: property.id,
            moveItem: (oldIndex, newIndex) =>
              this.moveCriteria(oldIndex, newIndex),
            findItem: (dragId) => this.findCriteria(dragId),
            deleteCriteria: () => this.deleteCriteria(index),
            property: property,
            setDragMarker: (dragMarker) => this.setState({ dragMarker }),
            dragMarker: dragMarker,
          }}
        />
      )
    })
  }

  getFamilyMemberPropertyRows() {
    const { properties = [] } = this.props // redux
    const { familyMemberPropertyIds, familyCriteriaPropertyIds } = this.props //ownProps
    const unusedPropertyIds = familyMemberPropertyIds.filter(
      (memberId) => !familyCriteriaPropertyIds.includes(memberId)
    )
    return unusedPropertyIds.map((propertyId, index) => {
      const property =
        properties.find((property) => property.id === propertyId) || {}
      if (!property) return false
      return (
        <Table.Row key={property.id}>
          <Table.Cell>{property.id}</Table.Cell>
          <Table.Cell>
            <span className="german tag">{property.name_de}</span>
            <span className="french tag">{property.name_fr}</span>
          </Table.Cell>
          <Table.Cell>
            <Icon
              name="chevron right"
              onClick={() => this.addCriteria(property.id)}
            />
          </Table.Cell>
        </Table.Row>
      )
    })
  }

  render() {
    const dark = config.theme.dark
    return (
      <Segment attached className={classNames([dark && 'inverted'])}>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column width={6}>
              <Header
                as="h3"
                dividing
                content={I18n.t(i18nkey + 'all_properties')}
              />
              <Table
                sortable
                compact
                size="small"
                selectable
                singleLine
                basic="very"
                className="spaced">
                <Table.Body children={this.getFamilyMemberPropertyRows()} />
              </Table>
            </Grid.Column>
            <Grid.Column width={6}>
              <Header
                as="h3"
                dividing
                content={I18n.t(i18nkey + 'selected_criteria')}
              />
              <Table
                sortable
                compact
                size="small"
                selectable
                singleLine
                basic="very"
                className="spaced">
                <Table.Body children={this.getCriteriaPropertyRows()} />
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    )
  }
}

ProductCriteriaProperties = connect(mapStateToProps)(ProductCriteriaProperties)
ProductCriteriaProperties = formValues('familyCriteriaPropertyIds')(
  ProductCriteriaProperties
)
// note: this is a test, decorating this component with the same form name as the parent component
// if this causes problems, import arrayPush
ProductCriteriaProperties = reduxForm()(ProductCriteriaProperties)
export default ProductCriteriaProperties



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductCriteriaProperties.jsx